<template>
    <div class="versionservice">
        <div class="top_box flex">
            <div class="standard">
                <div class="title_box">
                    <h3>{{standard.servicename}}</h3>
                    <p>适用于个人、小型内容团队，及<br>在线教育或知识付费行业新手</p>
                </div>
                <div class="price_box">
                    <div class="price flex">
                        <span>¥</span>
                        &nbsp<p>{{standard.servicemoney}}</p>&nbsp
                        <span>/年</span>
                    </div>
                    <div class="order_btn" @click="toOrderVersion(standard.servicename)">立即订购</div>
                </div>
                <div class="fun_list">
                    <h4>功能</h4>
                    <div class="list">
                        <p v-for="(item, index) in standardFList">
                            <img :src="blueArrow">
                            <span>{{item.value}}</span>
                        </p>
                    </div>
                </div>
            </div>
            <div class="standard EE">
                <div class="title_box">
                    <h3>{{cc.servicename}}</h3>
                    <p>适用于中小型知识付费内容<br>提供商及教育机构</p>
                </div>
                <div class="price_box">
                    <div class="price flex">
                        <span>¥</span>
                        &nbsp<p>{{cc.servicemoney}}</p>&nbsp
                        <span>/年</span>
                    </div>
                    <div class="order_btn" @click="toOrderVersion(cc.servicename)">立即订购</div>
                </div>
                <div class="fun_list">
                    <h4>功能</h4>
                    <div class="list">
                        <p v-for="(item, index) in eeFList">
                            <img :src="blueArrow">
                            <span>{{item.value}}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom_box">
            <div class="border">
                <div class="collapse_title flex">
                    <p>功能</p>
                    <p>标准版</p>
                    <p>企业版</p>
                </div>
                <el-collapse v-model="activeNames">
                    <el-collapse-item v-for="(item, index) in functionList" :title="item.name" :name="item.name">
                        <div v-for="(sItem, sIdx) in item.items" class="flex">
                            <p>{{sItem.name}}</p>
                            <p><img v-if="sItem.schecked" :src="blueArrow"></p>
                            <p><img v-if="sItem.cchecked" :src="blueArrow"></p>
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </div>
            <div class="collapse_btns flex">
                <div></div>
                <div @click="toOrderVersion(standard.servicename)"><p>订购标准版</p></div>
                <div @click="toOrderVersion(cc.servicename)"><p>订购企业版</p></div>
            </div>
        </div>
        <!-- 已有订单提示弹窗 -- start -->
        <div class="cancel_alert">
            <el-dialog title="提示" :visible.sync="dialogVisible" width="35%">
                <span>您有一笔未支付的订单，需完成原订单后才能下单</span>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="cancelOrder">去支付</el-button>
                </span>
            </el-dialog>
        </div>
        <!-- 已有订单提示弹窗 -- end -->
    </div>
</template>

<script>
import {getServiceshopmoduleList, savePriceBuyInfo} from '@/api/orderService'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'versionService',
    data() {
        return {
            standardFList: [
                {
                    value: '店铺管理'
                },
                {
                    value: '内容运营'
                },
                {
                    value: '鲸准推送'
                },
                {
                    value: '客户中心'
                },
                {
                    value: '交易管理'
                },
                {
                    value: '数据中心'
                },
                {
                    value: '账户设置'
                },
                {
                    value: '鲸选云盘'
                },
                {
                    value: '订购服务'
                },
                {
                    value: '公众号'
                }
            ],
            eeFList: [
                {
                    value: '店铺管理'
                },
                {
                    value: '内容运营'
                },
                {
                    value: '鲸准推送'
                },
                {
                    value: '客户中心'
                },
                {
                    value: '交易管理'
                },
                {
                    value: '数据中心'
                },
                {
                    value: '账户设置'
                },
                {
                    value: '鲸选云盘'
                },
                {
                    value: '订购服务'
                },
                {
                    value: '公众号'
                },
                {
                    value: '社群运营'
                },
                {
                    value: '全民分销'
                },
                {
                    value: '全民拼购'
                },
                {
                    value: '全民助力'
                }
            ],
            blueArrow: require('@/common/images/other/blue_arrow.png'),
            activeNames: ['内容运营'],
            functionList: [
                {
                    name: '店铺管理',
                    items: [
                        {
                            name: '移动端',
                            schecked: true,
                            cchecked: true
                        },
                        {
                            name: '商品分组',
                            schecked: true,
                            cchecked: true
                        },
                        {
                            name: '店铺模板',
                            schecked: true,
                            cchecked: true
                        }
                    ]
                },
                {
                    name: '内容运营',
                    items: [
                        {
                            name: '图文',
                            schecked: true,
                            cchecked: true
                        },
                        {
                            name: '报告/电子书',
                            schecked: true,
                            cchecked: true
                        },
                        {
                            name: '直播',
                            schecked: true,
                            cchecked: true
                        },
                        {
                            name: '视频',
                            schecked: true,
                            cchecked: true
                        },
                        {
                            name: '专栏',
                            schecked: true,
                            cchecked: true
                        }
                    ]
                },
                {
                    name: '社群运营',
                    items: [
                        {
                            name: '我的星球',
                            schecked: false,
                            cchecked: true
                        },
                        {
                            name: '敏感词',
                            schecked: false,
                            cchecked: true
                        },
                        {
                            name: '等级设置',
                            schecked: false,
                            cchecked: true
                        },
                        {
                            name: '积分设置',
                            schecked: false,
                            cchecked: true
                        }
                    ]
                },
                {
                    name: '全民分销',
                    items: [
                        {
                            name: '分销设置',
                            schecked: false,
                            cchecked: true
                        }
                    ]
                },
                {
                    name: '社群拼购',
                    items: [
                        {
                            name: '拼购设置',
                            schecked: false,
                            cchecked: true
                        }
                    ]
                },
                {
                    name: '全民助力',
                    items: [
                        {
                            name: '助力设置',
                            schecked: false,
                            cchecked: true
                        }
                    ]
                },
                {
                    name: '鲸准推送',
                    items: [
                        {
                            name: '短信',
                            schecked: true,
                            cchecked: true
                        },
                        {
                            name: '公众号',
                            schecked: true,
                            cchecked: true
                        }
                    ]
                },
                {
                    name: '客户中心',
                    items: [
                        {
                            name: '客户管理',
                            schecked: true,
                            cchecked: true
                        },
                        {
                            name: '评论管理',
                            schecked: true,
                            cchecked: true
                        },
                        {
                            name: '积分管理',
                            schecked: true,
                            cchecked: true
                        },
                        {
                            name: '会员管理',
                            schecked: true,
                            cchecked: true
                        }
                    ]
                },
                {
                    name: '交易管理',
                    items: [
                        {
                            name: '订单管理',
                            schecked: true,
                            cchecked: true
                        },
                        {
                            name: '余额管理',
                            schecked: true,
                            cchecked: true
                        },
                        {
                            name: '订单账户',
                            schecked: true,
                            cchecked: true
                        },
                        {
                            name: '数据中心',
                            schecked: true,
                            cchecked: true
                        }
                    ]
                },
                {
                    name: '账户设置',
                    items: [
                        {
                            name: '店铺设置',
                            schecked: true,
                            cchecked: true
                        },
                        {
                            name: '实名认证',
                            schecked: true,
                            cchecked: true
                        },
                        {
                            name: '子账户管理',
                            schecked: true,
                            cchecked: true
                        }
                    ]
                },
                {
                    name: '鲸选云盘',
                    items: [
                        {
                            name: '云盘设置',
                            schecked: true,
                            cchecked: true
                        }
                    ]
                },
                {
                    name: '订购服务',
                    items: [
                        {
                            name: '订购服务',
                            schecked: true,
                            cchecked: true
                        }
                    ]
                },
                {
                    name: '公众号',
                    items: [
                        {
                            name: '公众号',
                            schecked: true,
                            cchecked: true
                        }
                    ]
                }
            ],
            standard: '',
            cc: '',
            dialogVisible: false,
            orderno: ''
        }
    },
    mounted() {
        this.checkVersionService()
    },
    methods: {
        // 获取版本信息
        checkVersionService() {
            this.setLoading(true)
            getServiceshopmoduleList({
                data: {},
                success: data => {
                    if (data.data) {
                        let resData = data.data.openlist
                        // 将用户未订购的版本display start
                        let list = []
                        for (let i=0; i<resData.length; i++) {
                            if (!resData[i].isopenservice) {
                                list.push(resData[i])
                            }
                        }
                        this.openList = list
                        this.standard = list[0]
                        this.cc = list[1]
                        // end
                        
                        // this.openList = resData
                        // this.standard = resData[0]
                        // this.cc = resData[1]
                    }
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                }
            })
        },

        // 立即订购
        toOrderVersion(type) {
            type = type === '标准版' ? '1' : type === '专业版' ? '2' : type === '旗舰版' ? '3' : ''
            let data = {
                moduletype: '1',
                shopvertype: type
            }
            this.setLoading(true)
            savePriceBuyInfo({
                data: data,
                success: data => {
                    this.setLoading(false)
                    this.orderno = data.data.orderno
                    if (data.data.ispaysuccess === 2) {
                        this.dialogVisible = true
                    } else {
                        window.location = data.data.url
                        // this.$router.push({name: 'orderConfirm', query: {'orderno': data.data.orderno}})
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },

        // 取消订单
        cancelOrder() {
            this.$router.push({name: 'orderConfirm', query: {'orderno': this.orderno}})
        },
        ...mapActions ([
            'setLoading'
        ])
    }
}
</script>

<style lang="scss">
.flex {
    display: flex;
    align-items: center;
}
.versionservice {
    .top_box {
        height: 1100px;
        background: #fff;
        box-shadow: 2px 0px 6px 0px rgba(0,21,41,0.14);
        .standard {
            width: 340px;
            height: 980px;
            background: #fff;
            box-shadow: 0px 8px 24px 0px rgba(82,94,102,0.15);
            border-radius: 4px;
            // margin-left: 380px;
            margin: 0 auto;
            .title_box {
                width: 100%;
                height: 165px;
                background: #2FAFFF;
                color: #fff;
                text-align: center;
                h3 {
                    font-size: 36px;
                    padding: 30px 0 20px 0;
                }
                p {
                    font-size: 14px;
                    line-height: 24px;
                    opacity: .7;
                }
            }
            .price_box {
                height: 170px;
                border-bottom: 1px solid #DCDFE6;
                .price {
                    margin: 65px 0 50px;
                    justify-content: center;
                    align-items: flex-end;
                    p {
                        font-size: 40px;
                        color: #303133;
                        height: 30px;
                        line-height: 30px;
                    }
                    span:first-child {
                        font-size: 20px;
                        color: #303133;
                    }
                    span:last-child {
                        font-size: 16px;
                        color: #909399;
                    }
                }
                .order_btn {
                    width: 144px;
                    height: 50px;
                    background: linear-gradient(135deg,rgba(64,126,254,1) 0%,rgba(47,175,255,1) 100%);
                    border-radius: 4px;
                    color: #fff;
                    font-size: 16px;
                    text-align: center;
                    line-height: 50px;
                    margin: 0 auto;
                    cursor: pointer;
                }
            }
            .fun_list {
                width: 130px;
                margin: 0 auto;
                h4 {
                    font-size: 14px;
                    color: #909399;
                    margin: 30px 0 10px;
                }
                .list {
                    display: flex;
                    flex-direction: column;
                    p {
                        margin-bottom: 20px;
                        img {
                            display: inline-block;
                            width: 15px;
                            height: 12px;
                            margin: 0 40px 0 5px;
                        }
                        span {
                            font-size: 16px;
                            color: #303133;
                        }
                    }
                }
            }
        }
        .EE {
            // margin-left: 260px;
            .title_box {
                background: #407EFE;
            }
        }
    }
    .bottom_box {
        padding: 40px;
        background: #fff;
        margin-top: 20px;
        box-shadow: 2px 0px 6px 0px rgba(0,21,41,0.14);
        .border {
            border: 1px solid #C0C4CC;
            .collapse_title {
                padding: 0 24px;
                background: #FAFAFA;
                height: 50px;
                p {
                    flex: 1;
                    font-size: 18px;
                    font-weight: 600;
                    color: #303133;
                }
            }
            .el-collapse {
                // border: 1px solid #C0C4CC;
                color: #303133;
                .el-collapse-item__header {
                    background: #FAFAFA;
                    padding: 0 24px;
                    font-size: 18px;
                    font-weight: 520;
                }
                .el-collapse-item__content {
                    padding: 10px 24px;
                    font-size: 14px;
                    div {
                        justify-content: space-between;
                        line-height: 40px;
                        p {
                            flex: 1;
                            img {
                                display: inline-block;
                                width: 15px;
                                height: 12px;
                            }
                        }
                    }
                }
            }
        }
        .collapse_btns {
            height: 80px;
            box-shadow: 0px -1px 8px 0px rgba(0,0,0,0.06);
            div {
                flex: 1;
                cursor: pointer;
                p {
                    width: 160px;
                    height: 50px;
                    background: linear-gradient(135deg,rgba(64,126,254,1) 0%,rgba(47,175,255,1) 100%);
                    border-radius: 4px;
                    text-align: center;
                    line-height: 50px;
                    font-size: 14px;
                    color: #fff;
                }
            }
            div:first-child {
                margin-left: -80px;
            }
        }
    }
    .cancel_alert {
        .el-dialog {
            text-align: center;
            .el-dialog__header {
                text-align: left;
            }
            .el-dialog__body {
                color: #F56C6C;
            }
        }
    }
}
</style>


